<template>
  <v-menu :disabled="$attrs.disabled" offset-y>
    <template #activator="{ on }">
      <slot name="activator" v-bind="{ on }" />
    </template>
    <ul style="background-color: #fff" class="py-2">
      <li
        v-for="(item, idx) in items"
        :key="idx"
        class="font-size-14 font-lighten-1--text px-4 py-2 cursor-pointer menu"
        @click="$emit(item.name, returnObject ? item : item.name)"
      >
        {{ item.straightText || $i18n.t(item.text) }}
      </li>
    </ul>
  </v-menu>
</template>

<script>
export default {
  name: 'MenuItems',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.menu:hover {
  background-color: map-get($colors, 'primary-lighten-1');
}
</style>
